import { default as RoutePolicyConstructor } from './routepolicy';
export const RoutePolicy = new RoutePolicyConstructor();
